import {
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Grid,
    IconButton
} from '@material-ui/core';
import { Add, Delete } from '@material-ui/icons';
import {
    HarmonisedDialogTitle,
    HarmonisedModalActions
} from '../../Common/UI';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { connect, useSelector } from 'react-redux';
import { CommonDispatcher, OpenModal } from '../../../redux/Common/action';
import { SHOW_SNACKBAR } from '../../../redux/Common/actionTypes';
import { GetFirmsList, UpdateFirm } from '../../../redux/Firms/actions';
import { ADD_MARKETING_MODAL } from '../../../redux/ModalReducer/actionTypes';
import { GetSingleUser, UpdateUserProfile } from '../../../redux/Users/actions';
import { RootState } from '../../../redux/store';
import RenderTextField from '../../InputComponents/TextField/RenderTextField';

const AddMarketingEmailModal = ({
    OpenModal,
    UpdateUserProfile,
    CommonDispatcher,
    GetSingleUser
}) => {
    const modal: any =
        useSelector(
            (store: RootState) => store?.modal?.addMarketingEmailModal
        ) || {};
    const [cookies] = useCookies(['pgAdminToken']);
    const token = cookies['pgAdminToken'];
    const [loading, setLoading] = useState(false);
    const user_id = modal?.data?.selectedUser?.user_id;
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);

    const {
        control,
        errors: formError,
        formState: { isValid },
        getValues,
        setValue,
        reset
    } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onChange',
        shouldUnregister: false
    });
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'admin_marketing_emails'
    });

    useEffect(() => {
        setLoading(true);
        getSingleUser();
    }, []);

    const getSingleUser = () => {
        GetSingleUser(token, { user_id }).then((x) => {
            if (x?.type === 'success') {
                const admin_marketing_emails =
                    x?.response?.admin_marketing_emails;

                const updateFirms = admin_marketing_emails.map((item) => {
                    return {
                        email: item.email,
                        name: item.name
                    };
                });
                if (updateFirms?.length) {
                    reset({ admin_marketing_emails: updateFirms });
                } else {
                    reset({
                        admin_marketing_emails: [{ name: '', email: '' }]
                    });
                }
            }
            setLoading(false);
        });
    };

    const handleClose = () => {
        OpenModal(ADD_MARKETING_MODAL, { isOpen: false });
    };

    const handleUpdate = () => {
        setIsUpdateLoading(true);
        updateFirmsList();
    };

    const updateFirmsList = () => {
        UpdateUserProfile(token, { user_id, ...getValues() }).then((r) => {
            if (r?.response?.data?.error) {
                CommonDispatcher(SHOW_SNACKBAR, {
                    isShowing: true,
                    message: r?.response?.data?.error || 'Failed to update.',
                    hideAlert: true,
                    error: true
                });
            } else {
                getSingleUser();
                CommonDispatcher(SHOW_SNACKBAR, {
                    isShowing: true,
                    message: 'Updated successfully.'
                });
            }
            setIsUpdateLoading(false);
            setLoading(false);
            handleClose();
        });
    };

    const [username, setUsername] = useState([]);

    const handleNameChange = (index, e) => {
        setValue(`admin_marketing_emails[${index}].name`, e?.target?.value);
    };

    const handleEmailChange = (index, e) => {
        setValue(`admin_marketing_emails[${index}].email`, e?.target?.value);
    };
    console.log('ff', modal?.data?.selectedUser);

    return (
        <Dialog
            className="w-100"
            maxWidth="sm"
            fullWidth={modal?.config?.fullWidth || true}
            open={modal?.isOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <HarmonisedDialogTitle onClose={handleClose}>
                {modal?.title}
            </HarmonisedDialogTitle>
            <DialogContent>
                {loading ? (
                    <CircularProgress
                        size="1.3rem"
                        className="circular-progress m-auto d-flex"
                    />
                ) : (
                    <>
                        <Grid container spacing={3} className="mb-3">
                            <Grid item xs={12} className="py-1">
                                <div className="w-100 d-flex flex-direction-xs-column align-items-flex-start">
                                    <div className="mt-2 mr-3 w-100">
                                        <RenderTextField
                                            label={`Your Name`}
                                            value={
                                                modal?.data?.selectedUser
                                                    ?.full_name
                                            }
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="mt-2 mr-3 w-100">
                                        <RenderTextField
                                            label={`Your Email`}
                                            value={
                                                modal?.data?.selectedUser?.email
                                            }
                                            disabled={true}
                                        />
                                    </div>
                                    <IconButton
                                        color="secondary"
                                        className="invisible"
                                    >
                                        <Delete />
                                    </IconButton>
                                </div>
                                {fields.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="w-100 d-flex flex-direction-xs-column align-items-flex-start"
                                        >
                                            <div className="mt-2 mr-3 w-100">
                                                <Controller
                                                    name={`admin_marketing_emails[${index}].name`}
                                                    render={({
                                                        onChange,
                                                        value
                                                    }) => {
                                                        return (
                                                            <RenderTextField
                                                                id={`admin_marketing_emails[${index}].name`}
                                                                label={`Name ${
                                                                    index + 1
                                                                } *`}
                                                                value={value}
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    onChange(e);
                                                                    handleNameChange(
                                                                        index,
                                                                        e
                                                                    );
                                                                }}
                                                                placeholder="Search or Add name"
                                                            />
                                                        );
                                                    }}
                                                    control={control}
                                                    defaultValue={
                                                        item.name || null
                                                    }
                                                    rules={{
                                                        required: false
                                                    }}
                                                />
                                            </div>
                                            <div className="mt-2 mr-3 w-100">
                                                <Controller
                                                    name={`admin_marketing_emails[${index}].email`}
                                                    render={({
                                                        onChange,
                                                        value
                                                    }) => {
                                                        return (
                                                            <RenderTextField
                                                                inputContainerClassName="w-100"
                                                                type="text"
                                                                id={`admin_marketing_emails[${index}].email`}
                                                                label={`Email ${
                                                                    index + 1
                                                                } *`}
                                                                placeholder="Search or Add email"
                                                                value={value}
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    onChange(e);
                                                                    handleEmailChange(
                                                                        index,
                                                                        e
                                                                    );
                                                                }}
                                                                autoComplete="off"
                                                            />
                                                        );
                                                    }}
                                                    control={control}
                                                    defaultValue={
                                                        item.email || null
                                                    }
                                                    rules={{
                                                        required: false
                                                    }}
                                                />
                                            </div>
                                            <IconButton
                                                color="secondary"
                                                onClick={() => {
                                                    remove(index);
                                                    delete username[index];
                                                    setUsername(username);
                                                    // delete website[index];
                                                    // setFirmWebsite(website);
                                                }}
                                                className="d-flex align-self-flex-xs-end mt-5 mt-xs-0"
                                            >
                                                <Delete />
                                            </IconButton>
                                        </div>
                                    );
                                })}
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} className="mb-3">
                            <Grid item xs={12} className="mt-3">
                                <Button
                                    color="primary"
                                    variant="outlined"
                                    type="button"
                                    className="float-right"
                                    onClick={() => {
                                        append({ name: '', email: '' });
                                    }}
                                >
                                    <Add className="mr-2" />
                                    Add a email
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                )}
            </DialogContent>
            <HarmonisedModalActions
                onCancel={handleClose}
                onSubmit={handleUpdate}
                submitLabel="Update"
                submitting={isUpdateLoading}
            />
        </Dialog>
    );
};

export default connect(null, {
    OpenModal,
    UpdateUserProfile,
    CommonDispatcher,
    GetSingleUser
})(AddMarketingEmailModal);
